import React, { lazy } from "react";
import { Route } from "react-router-dom";
import ProtectedRoute from "./ProtextedRoute";
import { routes } from "@/config/routes";
import { AccountType } from "@/types";

const UserBoard = lazy(() => import("@/pages/MyBoard"));
const UserLeads = lazy(() => import("@/pages/MyBoard/Leads"));
const CreateLead = lazy(() => import("@/pages/Leads/Create"));
const UserOpportunities = lazy(() => import("@/pages/MyBoard/Opportunities"));
const UserQuotes = lazy(() => import("@/pages/MyBoard/Quotes"));
const LeadDetails = lazy(() => import("@/pages/CommandCenter/Leads/Details"));
const ConvertLead = lazy(() => import("@/pages/CommandCenter/Leads/Convert"));
const UploadLeads = lazy(() => import("@/pages/Leads/Upload"));
const CreateOpportunity = lazy(() => import("@/pages/CommandCenter/Opportunities/Create"));
const OpportunityDetails = lazy(() => import("@/pages/CommandCenter/Opportunities/Details"));
const QuoteDetails = lazy(() => import("@/pages/CommandCenter/Quotes/Details"));
const QuoteCheckout = lazy(() => import("@/pages/Quotes/Checkout"));
const MyBoardOrders = lazy(() => import("@/pages/MyBoard/Orders"));
const OrderDetails = lazy(() => import("@/pages/CommandCenter/Orders/Details"));
const UserProposals = lazy(() => import("@/pages/MyBoard/Proposals"));

const SettingsRoutes = (
    <React.Fragment>
        {/* User Board */}
        <Route
            path={routes.myWorkspace.root}
            element={<ProtectedRoute allowedAccountTypes={[AccountType.INTERNAL]}><UserBoard /></ProtectedRoute>}
        />

        {/* User Leads */}
        <Route
            path={routes.myWorkspace.leads.root}
            element={<ProtectedRoute allowedAccountTypes={[AccountType.INTERNAL]}><UserLeads /></ProtectedRoute>}
        />
         <Route
            path={routes.myWorkspace.leads.create}
            element={<ProtectedRoute allowedAccountTypes={[AccountType.INTERNAL]}><CreateLead /></ProtectedRoute>}
        />
        <Route
            path={routes.myWorkspace.leads.details}
            element={<ProtectedRoute allowedAccountTypes={[AccountType.INTERNAL]}><LeadDetails /></ProtectedRoute>}
        />
        <Route
            path={routes.myWorkspace.leads.convert}
            element={<ProtectedRoute allowedAccountTypes={[AccountType.INTERNAL]}><ConvertLead /></ProtectedRoute>}
        />
        <Route
            path={routes.myWorkspace.leads.upload}
            element={<ProtectedRoute allowedAccountTypes={[AccountType.INTERNAL]}><UploadLeads /></ProtectedRoute>}
        />
        {/* User Opportunities */}
        <Route
            path={routes.myWorkspace.opportunities.root}
            element={<ProtectedRoute allowedAccountTypes={[AccountType.INTERNAL]}><UserOpportunities /></ProtectedRoute>}
        />
        <Route
            path={routes.myWorkspace.opportunities.create}
            element={<ProtectedRoute allowedAccountTypes={[AccountType.INTERNAL]}><CreateOpportunity /></ProtectedRoute>}
        />
        <Route
            path={routes.myWorkspace.opportunities.details}
            element={<ProtectedRoute allowedAccountTypes={[AccountType.INTERNAL]}><OpportunityDetails /></ProtectedRoute>}
        />

        {/* User Quotes */}
        <Route
            path={routes.myWorkspace.quotes.root}
            element={<ProtectedRoute allowedAccountTypes={[AccountType.INTERNAL]}><UserQuotes /></ProtectedRoute>}
        />
        <Route
            path={routes.myWorkspace.quotes.details}
            element={<ProtectedRoute allowedAccountTypes={[AccountType.INTERNAL]}><QuoteDetails /></ProtectedRoute>}
        />
        <Route
            path={routes.myWorkspace.quotes.checkout}
            element={<ProtectedRoute allowedAccountTypes={[AccountType.INTERNAL]}><QuoteCheckout /></ProtectedRoute>}
        />

        {/* User Orders */}
        <Route
            path={routes.myWorkspace.orders.root}
            element={<ProtectedRoute allowedAccountTypes={[AccountType.INTERNAL]}><MyBoardOrders /></ProtectedRoute>}
        />
        <Route
            path={routes.myWorkspace.orders.details}
            element={<ProtectedRoute allowedAccountTypes={[AccountType.INTERNAL]}><OrderDetails /></ProtectedRoute>}
        />

        {/* User Proposals */}
        <Route
            path={routes.myWorkspace.proposals.root}
            element={<ProtectedRoute allowedAccountTypes={[AccountType.INTERNAL]}><UserProposals /></ProtectedRoute>}
        />
    </React.Fragment>
)

export default SettingsRoutes;
